// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --skeleton-background: rgba(0, 0, 0, 0.05);
  --skeleton-highlight: rgba(0, 0, 0, 0.1);
  --skeleton-animation-duration: 1.5s;
}

.Skeleton-module-skeleton {
  background-color: var(--skeleton-background);
  border-radius: 5px;
  display: flex;
  overflow: hidden;
  max-width: 100%;
}

.Skeleton-module-skeleton::after {
  content: "";
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, var(--skeleton-highlight), transparent);
  animation: Skeleton-module-shimmer var(--skeleton-animation-duration) infinite;
}

@keyframes Skeleton-module-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-color-scheme: dark) {

  :root {
    --skeleton-background: rgba(255, 255, 255, 0.05);
    --skeleton-highlight: rgba(255, 255, 255, 0.1);
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Skeleton/Skeleton.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uFAAuF;EACvF,8EAA8D;AAChE;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE;IACE,gDAAgD;IAChD,8CAA8C;EAChD;;AAEF","sourcesContent":[":root {\r\n  --skeleton-background: rgba(0, 0, 0, 0.05);\r\n  --skeleton-highlight: rgba(0, 0, 0, 0.1);\r\n  --skeleton-animation-duration: 1.5s;\r\n}\r\n\r\n.skeleton {\r\n  background-color: var(--skeleton-background);\r\n  border-radius: 5px;\r\n  display: flex;\r\n  overflow: hidden;\r\n  max-width: 100%;\r\n}\r\n\r\n.skeleton::after {\r\n  content: \"\";\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, var(--skeleton-highlight), transparent);\r\n  animation: shimmer var(--skeleton-animation-duration) infinite;\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% {\r\n    transform: translateX(-100%);\r\n  }\r\n  100% {\r\n    transform: translateX(100%);\r\n  }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n\r\n  :root {\r\n    --skeleton-background: rgba(255, 255, 255, 0.05);\r\n    --skeleton-highlight: rgba(255, 255, 255, 0.1);\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var skeleton = `Skeleton-module-skeleton`;
export var shimmer = `Skeleton-module-shimmer`;
export default ___CSS_LOADER_EXPORT___;
